// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: `${string}://src` | (string & {})
}

/**
 * AccountType
 *
 * Generic account type for customer portal invitations.
 */
export const AccountType = { FULL: 'FULL', LIMITED: 'LIMITED' } as const

/**
 * AccountType
 *
 * Generic account type for customer portal invitations.
 */
export type AccountType = (typeof AccountType)[keyof typeof AccountType]

/**
 * AddQuotation
 *
 * Create a new quotation.
 */
export type AddQuotation = {
  /**
   * Relationid
   */
  relationId: string
  /**
   * Relationname
   */
  relationName: string
  /**
   * Customerid
   */
  customerId: string
}

/**
 * Address
 *
 * OpenDoors quotation address.
 */
export type Address = {
  /**
   * Customerid
   */
  customerId: string
  /**
   * Addressid
   */
  addressId: string
  /**
   * Name
   */
  name: string
  /**
   * Nameext
   */
  nameExt?: string | null
  /**
   * Address
   */
  address: string
  /**
   * Address2
   */
  address2: string
  /**
   * Address3
   */
  address3?: string | null
  /**
   * Postalcode
   */
  postalCode: string
  /**
   * State
   */
  state: string
  /**
   * City
   */
  city: string
  /**
   * Countrycode
   */
  countryCode: string
  /**
   * Phone
   */
  phone?: string | null
  /**
   * Fax
   */
  fax?: string | null
  /**
   * Email
   */
  email: string
  /**
   * Website
   */
  website?: string | null
  /**
   * Vatnumber
   */
  vatNumber?: string | null
}

/**
 * Body_quotations-upload
 */
export type BodyQuotationsUpload = {
  /**
   * Upload File
   */
  upload_file: Blob | File
}

/**
 * CacheStats
 *
 * Statistics for a single application cache.
 */
export type CacheStats = {
  /**
   * Items
   *
   * Current number of items in the cache.
   */
  items: number
  /**
   * Capacity
   *
   * Configured maximum capacity of the cache, if bounded.
   */
  capacity?: number | null
  /**
   * Utilization
   *
   * Ratio of items to capacity (0.0 - 1.0).
   */
  utilization?: number | null
}

/**
 * Column
 *
 * Imported column.
 */
export type Column = {
  /**
   * Id
   */
  id: string
  /**
   * Index
   *
   * Index in the table (0-based).
   */
  index: number
  /**
   * Position
   *
   * A1 notation of the original postion in imported spreadsheet.
   */
  position: string
  /**
   * Name
   */
  name: string
  /**
   * Parent
   */
  parent: string
  /**
   * Is mapped?
   *
   * Is this column used in any mapping rules?
   */
  isMapped: boolean
  /**
   * Hide
   *
   * Do not display in UI.
   */
  hide: boolean
}

/**
 * ColumnVisibility
 *
 * Column visibility state.
 */
export type ColumnVisibility = {
  /**
   * Column ID
   */
  id: string
  /**
   * Hide in UI
   */
  hide: boolean
}

/**
 * CombinedOrderPage
 *
 * Cursor-paginated API view for combined order results.
 */
export type CombinedOrderPage = {
  /**
   * Items
   */
  items: Array<CombinedOrderView>
  /**
   * Nextcursor
   */
  nextCursor: string | null
}

/**
 * CombinedOrderView
 *
 * API view for combined (current and historical) order list entries.
 */
export type CombinedOrderView = {
  /**
   * Projectnumber
   */
  projectNumber: string | null
  /**
   * Projectid
   */
  projectId: number | null
  customer: OpendoorsApiOrdersSchemasCustomer
  /**
   * Customerreference
   */
  customerReference: string | null
  /**
   * Description
   */
  description: string | null
  status: ProjectStatus | null
  /**
   * Totalordervalue
   */
  totalOrderValue: number | string | null
  /**
   * Nextdeliverydate
   */
  nextDeliveryDate: Date | null
  /**
   * Tripcode
   */
  tripCode: string | null
  /**
   * Doorstodelivercount
   */
  doorsToDeliverCount: number | null
  /**
   * Trackandtrace
   */
  trackAndTrace: boolean | null
}

/**
 * ConfigurationNode
 *
 * Configuration tree node.
 */
export type ConfigurationNode = {
  /**
   * Id
   */
  id: string
  /**
   * Featureid
   */
  featureId: string
  /**
   * Name
   */
  name: string
  /**
   * Children
   */
  children: Array<ConfigurationNode>
  /**
   * Required
   */
  required: boolean
  /**
   * Minmax
   */
  minMax: [number, number] | null
  /**
   * Linkedid
   */
  linkedId: string | null
  /**
   * Islinked
   */
  isLinked: boolean
  /**
   * Hasmultiplier
   */
  hasMultiplier: boolean
}

/**
 * ConfigurationTree
 *
 * Configuration tree.
 */
export type ConfigurationTree = {
  /**
   * Id
   */
  id: string
  /**
   * Modelid
   */
  modelId: string
  /**
   * Name
   */
  name: string
  /**
   * Children
   */
  children: Array<ConfigurationNode>
}

/**
 * CostInformation
 *
 * Cost information schema.
 */
export type CostInformation = {
  /**
   * Transportation
   */
  transportation?: number | string | null
  /**
   * Customtransportation
   */
  customTransportation?: number | string | null
  /**
   * Kooiaap
   */
  kooiaap?: number | string | null
  /**
   * Packagematerials
   */
  packageMaterials?: number | string | null
  /**
   * Pallets
   */
  pallets?: number | string | null
  /**
   * Justintime
   */
  justInTime?: number | string | null
  /**
   * Urgency
   */
  urgency?: number | string | null
  /**
   * Alterations
   */
  alterations?: number | string | null
}

/**
 * CountryCodes
 *
 * Country schema.
 */
export type CountryCodes = {
  /**
   * Code
   */
  code: string
}

/**
 * CreateCustomerAddress
 *
 * Schema for creating a customer address.
 */
export type CreateCustomerAddress = {
  /**
   * Countrycode
   */
  countryCode: string
  /**
   * Name
   */
  name: string
  /**
   * Nameext
   */
  nameExt?: string | null
  /**
   * Address
   */
  address: string
  /**
   * Address2
   */
  address2?: string | null
  /**
   * Address3
   */
  address3?: string | null
  /**
   * Postalcode
   */
  postalCode?: string | null
  /**
   * State
   */
  state?: string | null
  /**
   * City
   */
  city: string
  /**
   * Phone
   */
  phone?: string | null
  /**
   * Fax
   */
  fax?: string | null
  /**
   * Email
   */
  email?: string | null
  /**
   * Website
   */
  website?: string | null
  /**
   * Vatnumber
   */
  vatNumber?: string | null
}

/**
 * CreateCustomerInvitation
 *
 * Payload to create or refresh a customer portal invitation.
 */
export type CreateCustomerInvitation = {
  /**
   * Email
   */
  email: string
  /**
   * Customerid
   *
   * External customer identifier
   */
  customerId: string
  accountType?: AccountType
}

/**
 * CreateCustomerRelation
 *
 * Schema for creating a customer relation.
 */
export type CreateCustomerRelation = {
  /**
   * Privatecountrycode
   */
  privateCountryCode: string
  /**
   * Name
   */
  name: string
  /**
   * Firstname
   */
  firstName?: string | null
  /**
   * Initials
   */
  initials: string
  genderCode?: GenderCode | null
  /**
   * Jobdescription
   */
  jobDescription?: string | null
  /**
   * Department
   */
  department?: string | null
  /**
   * Officephone
   */
  officePhone?: string | null
  /**
   * Officefax
   */
  officeFax?: string | null
  /**
   * Mobilephone
   */
  mobilePhone?: string | null
  /**
   * Email
   */
  email?: string | null
  /**
   * Subscribesalesquotcommtype
   */
  subscribeSalesQuotCommType?: number | null
  /**
   * Subscribeordconfcommtype
   */
  subscribeOrdConfCommType?: number | null
  /**
   * Subscribeshipdoccommtype
   */
  subscribeShipDocCommType?: number | null
  /**
   * Subscribesalesinvcommtype
   */
  subscribeSalesInvCommType?: number | null
  /**
   * Subscriberemindercommtype
   */
  subscribeReminderCommType?: number | null
}

/**
 * CreateCustomerRelationInvitation
 *
 * Payload to invite an Isah customer relation (contact person).
 */
export type CreateCustomerRelationInvitation = {
  /**
   * Customerid
   *
   * External customer identifier
   */
  customerId: string
  /**
   * Relationid
   *
   * Customer relation (contact person) code, unique within the customer
   */
  relationId: string
  accountType?: AccountType
}

/**
 * CreateInvoiceAddress
 *
 * Schema for creating a customer invoice address.
 */
export type CreateInvoiceAddress = {
  /**
   * Countrycode
   */
  countryCode: string
  /**
   * Email
   */
  email: string
  /**
   * Nameext
   */
  nameExt?: string | null
}

/**
 * CreateQuotationErrorResponse
 *
 * Error creating quotation.
 */
export type CreateQuotationErrorResponse = {
  /**
   * Type
   */
  type?: 'create_quotation'
  /**
   * Message
   */
  message: string
  /**
   * Configuration Id
   */
  configuration_id: string
}

/**
 * CurrencyCodes
 *
 * Currency code schema.
 */
export type CurrencyCodes = {
  /**
   * Code
   */
  code: string
  /**
   * Description
   */
  description?: string | null
}

/**
 * CustomerAddress
 *
 * Customer address.
 */
export type CustomerAddress = {
  /**
   * Customerid
   */
  customerId: string
  /**
   * Addressid
   */
  addressId: string
  /**
   * Name
   */
  name: string
  /**
   * Nameext
   */
  nameExt?: string | null
  /**
   * Address
   */
  address: string
  /**
   * Address2
   */
  address2: string
  /**
   * Address3
   */
  address3?: string | null
  /**
   * Postalcode
   */
  postalCode: string
  /**
   * State
   */
  state: string
  /**
   * City
   */
  city: string
  /**
   * Countrycode
   */
  countryCode: string
  /**
   * Phone
   */
  phone?: string | null
  /**
   * Fax
   */
  fax?: string | null
  /**
   * Email
   */
  email: string
  /**
   * Website
   */
  website?: string | null
  /**
   * Vatnumber
   */
  vatNumber?: string | null
}

/**
 * CustomerAddressResponse
 *
 * Response schema for a created customer address.
 */
export type CustomerAddressResponse = {
  /**
   * Addressid
   */
  addressId: string
}

/**
 * CustomerDetail
 *
 * Details of a customer.
 */
export type CustomerDetail = {
  /**
   * Id
   */
  id?: string | null
  /**
   * Name
   */
  name: string
  /**
   * Nameext
   */
  nameExt?: string | null
  /**
   * Address
   */
  address: string
  /**
   * Postalcode
   */
  postalCode: string
  /**
   * State
   */
  state: string
  /**
   * Countrycode
   */
  countryCode: string
  /**
   * City
   */
  city: string
  /**
   * Phone
   */
  phone?: string | null
  /**
   * Email
   */
  email: string
  /**
   * Lastmodified
   */
  lastModified?: Date | null
  /**
   * Lastmodifiedby
   */
  lastModifiedBy?: string | null
  /**
   * Vatnumber
   */
  vatNumber?: string | null
  /**
   * Currencycode
   */
  currencyCode?: string | null
  /**
   * Languagecode
   */
  languageCode?: string | null
  /**
   * Groupcode
   */
  groupCode?: string | null
  /**
   * Fax
   */
  fax?: string | null
  /**
   * Website
   */
  website?: string | null
  /**
   * Address2
   */
  address2: string
  /**
   * Address3
   */
  address3: string
  /**
   * Lobcode
   */
  lobCode?: string | null
  /**
   * Saleschannelid
   */
  salesChannelId?: string | null
}

/**
 * CustomerGroups
 *
 * Customer group schema.
 */
export type CustomerGroups = {
  /**
   * Code
   */
  code: string
  /**
   * Description
   */
  description: string
}

/**
 * CustomerInvitationResponse
 *
 * Customer portal invitation API response.
 */
export type CustomerInvitationResponse = {
  /**
   * Id
   */
  id: string
  /**
   * Email
   */
  email: string
  /**
   * Customerid
   */
  customerId: string
  /**
   * Relationid
   */
  relationId: string | null
  status: InvitationStatus
  /**
   * Expiresat
   */
  expiresAt: Date
  accountType: AccountType
}

/**
 * CustomerOrderStatus
 */
export const CustomerOrderStatus = {
  20: 20,
  40: 40,
  50: 50,
  60: 60,
  70: 70,
  93: 93,
  94: 94
} as const

/**
 * CustomerOrderStatus
 */
export type CustomerOrderStatus = (typeof CustomerOrderStatus)[keyof typeof CustomerOrderStatus]

/**
 * CustomerOrderView
 *
 * Customer order view.
 */
export type CustomerOrderView = {
  /**
   * Customername
   */
  customerName?: string | null
  /**
   * Projectdescription
   */
  projectDescription?: string | null
  /**
   * Orderreference
   */
  orderReference?: string | null
  /**
   * Ordernumber
   */
  orderNumber?: string | null
  /**
   * Line
   */
  line?: string | null
  /**
   * Doortype
   */
  doorType?: string | null
  /**
   * Quantity
   */
  quantity?: number | null
  /**
   * Height
   */
  height?: number | null
  /**
   * Width
   */
  width?: number | null
  /**
   * Thickness
   */
  thickness?: number | null
  /**
   * Marks
   */
  marks?: string | null
  /**
   * Fronthpl
   */
  frontHpl?: string | null
  /**
   * Backhpl
   */
  backHpl?: string | null
  /**
   * Deliveryaddress
   */
  deliveryAddress?: string | null
  /**
   * Deliveryweek
   */
  deliveryWeek?: string | null
  /**
   * Deliverymaincode
   */
  deliveryMainCode?: string | null
  salesStatus?: CustomerOrderStatus | null
  /**
   * Quantitydelivered
   */
  quantityDelivered?: number | null
  /**
   * Quantitytodeliver
   */
  quantityToDeliver?: number | null
  /**
   * Productionstartdate
   */
  productionStartDate?: Date | null
  /**
   * Productionenddate
   */
  productionEndDate?: Date | null
  /**
   * Deliverydatechange
   */
  deliveryDateChange?: string | null
}

/**
 * CustomerPortalUserGroupResponse
 *
 * Customer portal user count grouped by customer.
 */
export type CustomerPortalUserGroupResponse = {
  /**
   * Customerid
   */
  customerId: string
  /**
   * Usercount
   *
   * Number of accounts plus open invitations for this customer
   */
  userCount: number
}

/**
 * CustomerPortalUserResponse
 *
 * Customer portal account or open (pending or revoked) invitation.
 */
export type CustomerPortalUserResponse = {
  /**
   * Accountid
   *
   * Local OpenDoors Entra account ID; null while the invitation is not accepted
   */
  accountId: string | null
  /**
   * Invitationid
   *
   * Invitation ID; null for accounts provisioned without invitation
   */
  invitationId: string | null
  /**
   * Email
   */
  email: string
  /**
   * Customerid
   */
  customerId: string
  /**
   * Relationid
   */
  relationId: string | null
  accountType: AccountType | null
  /**
   * EXPIRED for pending invitations past expiry; null without invitation
   */
  invitationStatus: InvitationStatus | null
  /**
   * Invitationcreated
   *
   * When the invitation was first issued; null without invitation
   */
  invitationCreated: Date | null
  /**
   * Invitationmodified
   *
   * Last invitation change, e.g. re-invite or acceptance
   */
  invitationModified: Date | null
  /**
   * Invitationexpiresat
   */
  invitationExpiresAt: Date | null
  /**
   * Invitationacceptedat
   */
  invitationAcceptedAt: Date | null
  /**
   * Accountcreated
   *
   * When the Entra account was registered; null for pending invitations
   */
  accountCreated: Date | null
  /**
   * Accountmodified
   */
  accountModified: Date | null
}

/**
 * CustomerRelationQuotationList
 *
 * Response schema for Relations list.
 */
export type CustomerRelationQuotationList = {
  /**
   * Relationid
   */
  relationId: string
  /**
   * Customerid
   */
  customerId: string
  /**
   * Name
   */
  name: string
  /**
   * Email
   */
  email: string
}

/**
 * CustomerRelationResponse
 *
 * Response schema for a created customer relation.
 */
export type CustomerRelationResponse = {
  /**
   * Relationcode
   */
  relationCode: string
}

/**
 * DeleteCount
 *
 * Bulk delete response.
 */
export type DeleteCount = {
  /**
   * Number of deleted items.
   */
  count: number
}

/**
 * DeliveryAddressChangeWindowClosedErrorResponse
 *
 * Address changes are unavailable for inactive projects or expired deadlines.
 */
export type DeliveryAddressChangeWindowClosedErrorResponse = {
  /**
   * Type
   */
  type?: 'delivery_address_change_window_closed'
  /**
   * Message
   */
  message: string
  /**
   * Deadline
   */
  deadline?: Date | null
  /**
   * Delivery Date
   */
  delivery_date?: Date | null
}

/**
 * DeliveryConditions
 *
 * Delivery conditions schema.
 */
export type DeliveryConditions = {
  /**
   * Paymentterms
   */
  paymentTerms?: string | null
  /**
   * Deliveryterms
   */
  deliveryTerms?: string | null
  /**
   * Deliveryperiodtype
   */
  deliveryPeriodType?: string | null
  /**
   * Deliveryperiod
   */
  deliveryPeriod?: string | null
  address?: Address | null
}

/**
 * DerivedOrderStatus
 *
 * (Sub-)order status derived from order line statuses (Factory API).
 */
export const DerivedOrderStatus = {
  20: 20,
  40: 40,
  50: 50,
  60: 60,
  70: 70,
  93: 93,
  94: 94,
  '-1': -1
} as const

/**
 * DerivedOrderStatus
 *
 * (Sub-)order status derived from order line statuses (Factory API).
 */
export type DerivedOrderStatus = (typeof DerivedOrderStatus)[keyof typeof DerivedOrderStatus]

/**
 * DoorListFeature
 *
 * A feature in a door list.
 */
export type DoorListFeature = {
  /**
   * Id
   */
  id: string
  /**
   * Linkedid
   */
  linkedId: string | null
  /**
   * Featureid
   */
  featureId: string
  /**
   * Name
   */
  name: string
  type: NodeType
  /**
   * Required
   */
  required: boolean
  numberRange: NumberRange | null
  /**
   * Children
   */
  children: Array<DoorListFeature>
}

/**
 * DoorListItem
 *
 * Entry in the door list.
 */
export type DoorListItem = {
  /**
   * Id
   */
  id: string
  /**
   * Multiplier
   */
  multiplier: number
  /**
   * Name
   */
  name: string | null
  /**
   * Configuration
   */
  configuration: {
    [key: string]: DoorListValue
  }
}

/**
 * DoorListTree
 *
 * Quotation door list.
 */
export type DoorListTree = {
  /**
   * Doorlistid
   */
  doorListId: string
  /**
   * Configurationid
   */
  configurationId: string
  /**
   * Features
   */
  features: Array<DoorListFeature>
  /**
   * Items
   */
  items: Array<DoorListItem>
}

/**
 * DoorListValue
 *
 * Value for a feature in a door list item.
 */
export type DoorListValue = {
  /**
   * Value
   */
  value: string | boolean | number | number | null
  /**
   * Errors
   */
  errors: Array<ValidationValueError | ValidationConflict | ValidationMissingFeature>
}

/**
 * DoorSalesPeriodDto
 */
export type DoorSalesPeriodDto = {
  /**
   * Year
   */
  year?: number | null
  /**
   * Doors
   */
  doors?: number | string | null
  /**
   * Ordervalue
   */
  orderValue?: number | string | null
}

/**
 * DoorSalesSummary
 *
 * Door sales (revenue) summary: year-to-date and last year.
 */
export type DoorSalesSummary = {
  yearToDate?: DoorSalesPeriodDto | null
  lastYear?: DoorSalesPeriodDto | null
}

/**
 * EntraConfig
 *
 * Entra ID configuration.
 */
export type EntraConfig = {
  /**
   * Client app ID
   *
   * An UUID/GUID of the application configure for this project.
   */
  clientId: string
  /**
   * Tenant ID
   *
   * An UUID/GUID of the Entra ID tenant.
   */
  tenantId: string
  /**
   * Authority URI
   *
   * URI of the tenant to authenticate
   */
  authority: string
  /**
   * Scopes
   *
   * List of required scopes.
   */
  scopes: Array<string>
}

export type FeatureValue = string | boolean | number | number | null

/**
 * GenderCode
 */
export const GenderCode = {
  0: 0,
  1: 1,
  2: 2
} as const

/**
 * GenderCode
 */
export type GenderCode = (typeof GenderCode)[keyof typeof GenderCode]

/**
 * HTTPValidationError
 */
export type HttpValidationError = {
  /**
   * Detail
   */
  detail?: Array<ValidationError>
}

/**
 * HistoricalOrderDetailView
 *
 * API view for historical order detail data.
 */
export type HistoricalOrderDetailView = {
  /**
   * Projectnumber
   */
  projectNumber: string | null
  /**
   * Quotationnumber
   */
  quotationNumber: string | null
  customer: OpendoorsApiOrdersSchemasCustomer
  customerRelation: OpendoorsApiOrdersSchemasCustomerRelation
  /**
   * Deliverytermid
   */
  deliveryTermId: number | null
  /**
   * Frontofficesellername
   */
  frontOfficeSellerName: string | null
  /**
   * Backofficesellername
   */
  backOfficeSellerName: string | null
  /**
   * Externalreference
   */
  externalReference: string | null
  /**
   * Suborders
   */
  subOrders: Array<HistoricalOrderView>
}

/**
 * HistoricalOrderView
 *
 * API view for a sub-order within a historical order detail.
 */
export type HistoricalOrderView = {
  /**
   * Subordernumber
   */
  suborderNumber: number | null
  /**
   * Ordernumber
   */
  orderNumber: string | null
  /**
   * Dossiercode
   */
  dossierCode: string | null
  /**
   * Description
   */
  description: string | null
  /**
   * Ismainorder
   */
  isMainOrder: boolean | null
  status: DerivedOrderStatus | null
  /**
   * Deliverat
   */
  deliverAt: Date | null
  /**
   * Createdat
   */
  createdAt: Date | null
  deliveryAddress?: CustomerAddress | null
  /**
   * Orderlines
   */
  orderLines: Array<OrderDetailLineView>
}

/**
 * ImportFile
 *
 * Information about an uploaded spreadsheet file.
 */
export type ImportFile = {
  /**
   * Fileid
   */
  fileId: string
  /**
   * Quotationid
   */
  quotationId: string
  /**
   * Filename
   */
  fileName: string
  /**
   * Contenttype
   */
  contentType: string
  /**
   * Filesize
   */
  fileSize: number
  /**
   * Sheets
   */
  sheets: Array<string>
  options: ImportOptions
}

/**
 * ImportOptions
 *
 * Options for importing a spreadsheet file.
 */
export type ImportOptions = {
  /**
   * Selectedsheet
   */
  selectedSheet: string
  /**
   * Selecteddatarange
   */
  selectedDataRange: string
  /**
   * Selectedheaderrange
   */
  selectedHeaderRange: string
}

/**
 * ImportTable
 *
 * Imported table.
 */
export type ImportTable = {
  /**
   * Id
   */
  id: string
  /**
   * Quotationid
   */
  quotationId: string
  /**
   * Fileid
   */
  fileId: string | null
  /**
   * Configurationid
   */
  configurationId: string | null
  /**
   * Header
   */
  header: Array<Column>
  /**
   * Items
   */
  items: Array<Row>
}

/**
 * ImportValidationError
 *
 * Validity error for a selected door list feature.
 */
export type ImportValidationError = {
  /**
   * Msg
   */
  msg: string
}

/**
 * InvalidDeliveryAddressErrorResponse
 *
 * Selected delivery address does not exist or is invalid for the customer.
 */
export type InvalidDeliveryAddressErrorResponse = {
  /**
   * Type
   */
  type?: 'invalid_delivery_address'
  /**
   * Message
   */
  message: string
}

/**
 * InvitationStatus
 *
 * Lifecycle status of a customer portal invitation.
 */
export const InvitationStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED'
} as const

/**
 * InvitationStatus
 *
 * Lifecycle status of a customer portal invitation.
 */
export type InvitationStatus = (typeof InvitationStatus)[keyof typeof InvitationStatus]

/**
 * InvoiceAddress
 *
 * Invoice address response schema.
 */
export type InvoiceAddress = {
  /**
   * Customerid
   */
  customerId?: string | null
  /**
   * Addressid
   */
  addressId?: string | null
  /**
   * Countrycode
   */
  countryCode?: string | null
  /**
   * Nameext
   */
  nameExt?: string | null
  /**
   * Email
   */
  email?: string | null
}

/**
 * ItemValidation
 *
 * Item validation response.
 */
export type ItemValidation = {
  item: DoorListItem
  /**
   * Errors
   */
  errors: Array<ValidationValueError | ValidationConflict | ValidationMissingFeature>
  /**
   * Features
   */
  features: Array<DoorListFeature>
}

export const Language = {
  NL: 'nl',
  EN: 'en',
  DE: 'de'
} as const

export type Language = (typeof Language)[keyof typeof Language]

/**
 * LanguageCodes
 *
 * Language schema.
 */
export type LanguageCodes = {
  /**
   * Code
   */
  code: string
}

/**
 * LobCodes
 *
 * LOB code schema.
 */
export type LobCodes = {
  /**
   * Code
   */
  code: string
  /**
   * Description
   */
  description?: string | null
}

/**
 * MappingError
 *
 * Types of mapping errors.
 */
export const MappingError = { NOT_MAPPED: 'not_mapped' } as const

/**
 * MappingError
 *
 * Types of mapping errors.
 */
export type MappingError = (typeof MappingError)[keyof typeof MappingError]

/**
 * MappingValidationConflict
 *
 * Mapping configuration model validation error.
 */
export type MappingValidationConflict = {
  /**
   * Id
   */
  id: string
  /**
   * Type
   */
  type?: 'selection'
  /**
   * Alternatives
   */
  alternatives: Array<string>
  /**
   * Rulesetid
   */
  ruleSetId: string | null
}

/**
 * MappingValidationMissingFeature
 *
 * Mapping configuration model validation error.
 */
export type MappingValidationMissingFeature = {
  /**
   * Id
   */
  id: string
  /**
   * Type
   */
  type?: 'missing'
  /**
   * Rulesetid
   */
  ruleSetId: string | null
}

/**
 * MappingValidationValueError
 *
 * Mapping configuration model value error.
 */
export type MappingValidationValueError = {
  /**
   * Id
   */
  id: string
  /**
   * Type
   */
  type?: 'value'
  valueRequested: FeatureValue
  valueActual: FeatureValue
  /**
   * Rulesetid
   */
  ruleSetId: string | null
}

/**
 * MostUsedFeature
 *
 * A lightweight reference to a frequently mapped feature.
 */
export type MostUsedFeature = {
  /**
   * Id
   */
  id: string
  /**
   * Name
   */
  name: string
  /**
   * Parentnames
   */
  parentNames: Array<string>
}

/**
 * NodeType
 *
 * Type of node in configuration tree.
 */
export const NodeType = {
  NUMBER: 'number',
  STRING: 'string',
  OPTION: 'option',
  SELECT: 'select',
  MULTISELECT: 'multiselect',
  LIST: 'list',
  GROUP: 'group'
} as const

/**
 * NodeType
 *
 * Type of node in configuration tree.
 */
export type NodeType = (typeof NodeType)[keyof typeof NodeType]

/**
 * NumberRange
 *
 * Range of numbers.
 */
export type NumberRange = {
  /**
   * Min
   */
  min: number
  /**
   * Max
   */
  max: number
}

/**
 * OrderDetailLineView
 *
 * API view for a line item within a sub-order.
 */
export type OrderDetailLineView = {
  /**
   * Partcode
   */
  partCode: string | null
  /**
   * Description
   */
  description: string | null
  /**
   * Price
   */
  price: number | null
  /**
   * Quantity
   */
  quantity: number | null
  /**
   * Delmaincode
   */
  delMainCode: string | null
  /**
   * Marks
   */
  marks: string | null
}

/**
 * OrderDetailView
 *
 * API view for detailed order data.
 */
export type OrderDetailView = {
  /**
   * Orderid
   */
  orderId: number | null
  /**
   * Quotationnumber
   */
  quotationNumber: string | null
  customer: OpendoorsApiOrdersSchemasCustomer
  customerRelation: OpendoorsApiOrdersSchemasCustomerRelation
  /**
   * Deliverytermid
   */
  deliveryTermId: number | null
  /**
   * Frontofficesellername
   */
  frontOfficeSellerName: string | null
  /**
   * Backofficesellername
   */
  backOfficeSellerName: string | null
  /**
   * Externalreference
   */
  externalReference: string | null
  /**
   * Suborders
   */
  subOrders: Array<SubOrderView>
}

/**
 * OrderStatus
 *
 * Order status.
 */
export type OrderStatus = {
  /**
   * Code
   */
  code: string
  /**
   * Description
   */
  description: string
}

/**
 * OrderTransformErrorResponse
 *
 * Error transforming order to CPQ quotation.
 */
export type OrderTransformErrorResponse = {
  /**
   * Type
   */
  type?: 'order_transform_error'
  /**
   * Message
   */
  message: string
  /**
   * Cpq Id
   */
  cpq_id: string
}

/**
 * OrderView
 *
 * API view for order list entries.
 */
export type OrderView = {
  /**
   * Id
   */
  id: number | null
  customer: OpendoorsApiOrdersSchemasCustomer
  /**
   * Customerreference
   */
  customerReference: string | null
  /**
   * Quotationnumber
   */
  quotationNumber: string | null
  /**
   * Description
   */
  description: string | null
  status: ProjectStatus | null
}

/**
 * Page[CustomerAddress]
 */
export type PageCustomerAddress = {
  /**
   * Size
   *
   * Number of items per page.
   */
  size: number
  /**
   * I
   *
   * Starting index in the full result list.
   */
  i: number
  /**
   * Total
   *
   * Total number or items
   */
  total: number
  /**
   * Items
   *
   * Items of the current page.
   */
  items: Array<CustomerAddress>
}

/**
 * Page[CustomerOrderView]
 */
export type PageCustomerOrderView = {
  /**
   * Size
   *
   * Number of items per page.
   */
  size: number
  /**
   * I
   *
   * Starting index in the full result list.
   */
  i: number
  /**
   * Total
   *
   * Total number or items
   */
  total: number
  /**
   * Items
   *
   * Items of the current page.
   */
  items: Array<CustomerOrderView>
}

/**
 * Page[CustomerPortalUserGroupResponse]
 */
export type PageCustomerPortalUserGroupResponse = {
  /**
   * Size
   *
   * Number of items per page.
   */
  size: number
  /**
   * I
   *
   * Starting index in the full result list.
   */
  i: number
  /**
   * Total
   *
   * Total number or items
   */
  total: number
  /**
   * Items
   *
   * Items of the current page.
   */
  items: Array<CustomerPortalUserGroupResponse>
}

/**
 * Page[CustomerPortalUserResponse]
 */
export type PageCustomerPortalUserResponse = {
  /**
   * Size
   *
   * Number of items per page.
   */
  size: number
  /**
   * I
   *
   * Starting index in the full result list.
   */
  i: number
  /**
   * Total
   *
   * Total number or items
   */
  total: number
  /**
   * Items
   *
   * Items of the current page.
   */
  items: Array<CustomerPortalUserResponse>
}

/**
 * Page[CustomerRelationQuotationList]
 */
export type PageCustomerRelationQuotationList = {
  /**
   * Size
   *
   * Number of items per page.
   */
  size: number
  /**
   * I
   *
   * Starting index in the full result list.
   */
  i: number
  /**
   * Total
   *
   * Total number or items
   */
  total: number
  /**
   * Items
   *
   * Items of the current page.
   */
  items: Array<CustomerRelationQuotationList>
}

/**
 * Page[CustomerRelation]
 */
export type PageCustomerRelation = {
  /**
   * Size
   *
   * Number of items per page.
   */
  size: number
  /**
   * I
   *
   * Starting index in the full result list.
   */
  i: number
  /**
   * Total
   *
   * Total number or items
   */
  total: number
  /**
   * Items
   *
   * Items of the current page.
   */
  items: Array<OpendoorsApiCustomersSchemasCustomerRelation>
}

/**
 * Page[Customer]
 */
export type PageCustomer = {
  /**
   * Size
   *
   * Number of items per page.
   */
  size: number
  /**
   * I
   *
   * Starting index in the full result list.
   */
  i: number
  /**
   * Total
   *
   * Total number or items
   */
  total: number
  /**
   * Items
   *
   * Items of the current page.
   */
  items: Array<OpendoorsApiCustomersSchemasCustomer>
}

/**
 * Page[OrderView]
 */
export type PageOrderView = {
  /**
   * Size
   *
   * Number of items per page.
   */
  size: number
  /**
   * I
   *
   * Starting index in the full result list.
   */
  i: number
  /**
   * Total
   *
   * Total number or items
   */
  total: number
  /**
   * Items
   *
   * Items of the current page.
   */
  items: Array<OrderView>
}

/**
 * Page[QuotationDetail]
 */
export type PageQuotationDetail = {
  /**
   * Size
   *
   * Number of items per page.
   */
  size: number
  /**
   * I
   *
   * Starting index in the full result list.
   */
  i: number
  /**
   * Total
   *
   * Total number or items
   */
  total: number
  /**
   * Items
   *
   * Items of the current page.
   */
  items: Array<QuotationDetail>
}

/**
 * Page[RuleSet]
 */
export type PageRuleSet = {
  /**
   * Size
   *
   * Number of items per page.
   */
  size: number
  /**
   * I
   *
   * Starting index in the full result list.
   */
  i: number
  /**
   * Total
   *
   * Total number or items
   */
  total: number
  /**
   * Items
   *
   * Items of the current page.
   */
  items: Array<RuleSet>
}

/**
 * Page[SalesChannel]
 */
export type PageSalesChannel = {
  /**
   * Size
   *
   * Number of items per page.
   */
  size: number
  /**
   * I
   *
   * Starting index in the full result list.
   */
  i: number
  /**
   * Total
   *
   * Total number or items
   */
  total: number
  /**
   * Items
   *
   * Items of the current page.
   */
  items: Array<SalesChannel>
}

/**
 * PatchSuborderDeliveryAddress
 *
 * Request schema for partially updating delivery address contact details.
 */
export type PatchSuborderDeliveryAddress = {
  /**
   * Contactname
   */
  contactName?: string | null
  /**
   * Email
   */
  email?: string | '' | null
  /**
   * Phonenumber
   */
  phoneNumber?: string | null
}

/**
 * PreviewResult
 *
 * Preview result of a mapping rule set.
 */
export type PreviewResult = {
  /**
   * Rulesetid
   *
   * ID of the rule set used to create this result.
   */
  ruleSetId: string
  /**
   * Featureid
   *
   * ID feature this result maps to
   */
  featureId: string
  /**
   * Value
   *
   * Value of the feature
   */
  value: string
  /**
   * Optional mapping error indicator
   */
  error: MappingError | null
}

/**
 * PreviewRow
 *
 * Row of preview results.
 */
export type PreviewRow = {
  /**
   * Row ID
   *
   * Unique identifier for the row.
   */
  id: string
  /**
   * Index
   *
   * Index of the row in the table.
   */
  index: number
  /**
   * Position
   *
   * Position in the original imported spreadsheet file.
   */
  position: number
  /**
   * Source
   *
   * Mapping of source column IDs to values that were used.
   */
  source: {
    [key: string]: string
  }
  /**
   * Values
   *
   * Mapping of feature IDs to values that were mapped.
   */
  values: {
    [key: string]: PreviewResult
  }
}

/**
 * PreviewTable
 *
 * Preview of import mapping results.
 */
export type PreviewTable = {
  /**
   * Rows
   *
   * Rows with preview results.
   */
  rows: Array<PreviewRow>
  errors: PreviewTableError
}

/**
 * PreviewTableError
 *
 * General error information for preview table.
 */
export type PreviewTableError = {
  /**
   * Count
   */
  count?: number
}

/**
 * ProjectInformation
 *
 * Project information schema.
 */
export type ProjectInformation = {
  /**
   * Name
   */
  name: string
  /**
   * Reference
   */
  reference?: string | null
  /**
   * Salesagentinternal
   */
  salesAgentInternal?: string | null
  /**
   * Trajectorytype
   */
  trajectoryType?: string | null
  /**
   * Creationdate
   */
  creationDate?: string | null
  /**
   * Mutationdate
   */
  mutationDate?: string | null
  /**
   * Lastmodifiedby
   */
  lastModifiedBy?: string | null
}

/**
 * ProjectStatus
 *
 * Status of a project (combined/historical order) from the Factory API.
 */
export const ProjectStatus = { ACTIVE: 'Active', COMPLETED: 'Completed' } as const

/**
 * ProjectStatus
 *
 * Status of a project (combined/historical order) from the Factory API.
 */
export type ProjectStatus = (typeof ProjectStatus)[keyof typeof ProjectStatus]

/**
 * QuotationDetail
 *
 * OpenDoors detail quotation.
 */
export type QuotationDetail = {
  /**
   * Id
   */
  id: string
  relation: QuotationRelation
  customer: OpendoorsApiQuotationsSchemasCustomer
  /**
   * Number
   */
  number?: string
  /**
   * Salesagent
   */
  salesAgent?: string | null
  /**
   * Customerreference
   */
  customerReference?: string | null
  /**
   * Doors
   */
  doors?: number | null
  /**
   * Status
   */
  status?: string
  /**
   * Value
   */
  value?: number | string
  /**
   * Margin
   */
  margin?: number | string
  /**
   * Datedelivery
   */
  dateDelivery?: Date | null
  /**
   * Cpqid
   */
  cpqId?: string | null
  projectInformation: ProjectInformation
  costInformation: CostInformation
  deliveryConditions: DeliveryConditions
}

/**
 * QuotationId
 *
 * Quotation ID schema.
 */
export type QuotationId = {
  /**
   * Value
   */
  value: string
}

/**
 * QuotationRelation
 *
 * Relation schema for Quotation list.
 */
export type QuotationRelation = {
  /**
   * Id
   */
  id: string
  /**
   * Name
   */
  name: string
  /**
   * Mobilephone
   */
  mobilePhone: string | null
  /**
   * Email
   */
  email: string | null
}

/**
 * ReadinessCheck
 *
 * Result of a single readiness dependency check.
 */
export type ReadinessCheck = {
  status: ReadinessStatus
  /**
   * Latencyms
   */
  latencyMs?: number | null
  /**
   * Reason
   */
  reason?: string | null
}

/**
 * ReadinessProbe
 *
 * Readiness probe identifiers.
 */
export const ReadinessProbe = {
  DATABASE: 'database',
  ELFSQUAD: 'elfsquad',
  FACTORY_API: 'factory_api'
} as const

/**
 * ReadinessProbe
 *
 * Readiness probe identifiers.
 */
export type ReadinessProbe = (typeof ReadinessProbe)[keyof typeof ReadinessProbe]

/**
 * ReadinessReport
 *
 * Structured readiness response.
 */
export type ReadinessReport = {
  status: ReadinessStatus
  /**
   * Checks
   */
  checks: {
    [key in ReadinessProbe]?: ReadinessCheck
  }
}

/**
 * ReadinessStatus
 *
 * Overall readiness states.
 */
export const ReadinessStatus = { OK: 'ok', FAILED: 'failed' } as const

/**
 * ReadinessStatus
 *
 * Overall readiness states.
 */
export type ReadinessStatus = (typeof ReadinessStatus)[keyof typeof ReadinessStatus]

/**
 * Role
 *
 * Role definitions.
 */
export const Role = {
  ADMIN: 'admin',
  DEURGETEST: 'deurgetest',
  CP_USER: 'cp_user',
  CUSTOMER: 'customer',
  APPLICATION: 'application'
} as const

/**
 * Role
 *
 * Role definitions.
 */
export type Role = (typeof Role)[keyof typeof Role]

/**
 * Row
 *
 * Imported row.
 */
export type Row = {
  /**
   * Id
   */
  id: string
  /**
   * Index
   *
   * Index in the table (0-based).
   */
  index: number
  /**
   * Position
   *
   * Position in the original imported spreadsheet file.
   */
  position: number
  /**
   * Items
   */
  items: {
    [key: string]: Selection
  }
}

/**
 * RowValidation
 *
 * Row validation response.
 */
export type RowValidation = {
  item: Row
  /**
   * Errors
   */
  errors: Array<
    MappingValidationValueError | MappingValidationConflict | MappingValidationMissingFeature
  >
}

/**
 * Rule
 *
 * Import mapping rule.
 */
export type Rule = {
  type: RuleType
  /**
   * Featureid
   */
  featureId: string
  /**
   * Params
   */
  params: {
    [key: string]: string
  }
}

/**
 * RuleDefinition
 *
 * Define an available rule type.
 */
export type RuleDefinition = {
  type: RuleType
}

/**
 * RuleSet
 *
 * Set of import rules.
 */
export type RuleSet = {
  /**
   * Configuration node ID
   */
  nodeId: string
  /**
   * Fields
   */
  fields: Array<string>
  /**
   * Rules
   */
  rules: Array<Rule>
  /**
   * Rule set ID
   */
  id: string
  /**
   * Ordering index
   */
  index: number
}

/**
 * RuleSetChange
 *
 * New rule set data.
 */
export type RuleSetChange = {
  /**
   * Configuration node ID
   */
  nodeId: string
  /**
   * Fields
   */
  fields: Array<string>
  /**
   * Rules
   */
  rules: Array<Rule>
}

/**
 * RuleType
 *
 * Different types of mapping rules.
 */
export const RuleType = {
  REGEX: 'regex',
  NUMBER: 'number',
  STRING: 'string',
  STARTS_WITH: 'starts_with',
  MULTIPLIER: 'multiplier',
  NAME: 'name',
  CONTAINS: 'contains',
  DEFAULT_VALUE: 'default_value',
  REGEX_SELECT: 'regex_select',
  NUMBER_SELECT: 'number_select',
  NUMBER_SUFFIX: 'number_suffix'
} as const

/**
 * RuleType
 *
 * Different types of mapping rules.
 */
export type RuleType = (typeof RuleType)[keyof typeof RuleType]

/**
 * SalesChannel
 *
 * Sales channel that can be linked to customers.
 */
export type SalesChannel = {
  /**
   * Id
   */
  id: string
  /**
   * Name
   */
  name: string
}

/**
 * Selection
 *
 * Selected value for a door list feature.
 */
export type Selection = {
  /**
   * Value
   */
  value: string | number
  /**
   * Errors
   */
  errors: Array<ImportValidationError>
}

/**
 * SetDoorListValue
 *
 * Set value.
 */
export type SetDoorListValue = {
  /**
   * Value
   */
  value: string | boolean | number | number | null
}

/**
 * SubOrderView
 *
 * API view for a sub-order within an order detail.
 */
export type SubOrderView = {
  /**
   * Description
   */
  description: string
  /**
   * Ordernumber
   */
  orderNumber: string
  status: DerivedOrderStatus | null
  /**
   * Deliverat
   */
  deliverAt: Date | null
  /**
   * Createdat
   */
  createdAt: Date
  /**
   * Orderlines
   */
  orderLines: Array<OrderDetailLineView>
}

/**
 * SuborderTrackAndTraceView
 *
 * Response schema for a suborder's track and trace status.
 */
export type SuborderTrackAndTraceView = {
  /**
   * Trackandtrace
   */
  trackAndTrace: boolean
  /**
   * Customerid
   */
  customerId: string
  /**
   * Addressid
   */
  addressId: string | null
  /**
   * Email
   */
  email?: string | null
}

/**
 * UpdateCustomer
 *
 * Schema for updating a customer.
 */
export type UpdateCustomer = {
  /**
   * Name
   */
  name: string
  /**
   * Nameext
   */
  nameExt?: string | null
  /**
   * Vatnumber
   */
  vatNumber?: string | null
  /**
   * Currencycode
   */
  currencyCode: string
  /**
   * Languagecode
   */
  languageCode: string
  /**
   * Groupcode
   */
  groupCode: string
  /**
   * Lobcode
   */
  lobCode: string
  /**
   * Address
   */
  address: string
  /**
   * Address2
   */
  address2?: string | null
  /**
   * Address3
   */
  address3?: string | null
  /**
   * Postalcode
   */
  postalCode: string
  /**
   * State
   */
  state?: string | null
  /**
   * City
   */
  city: string
  /**
   * Countrycode
   */
  countryCode: string
  /**
   * Phone
   */
  phone: string
  /**
   * Fax
   */
  fax?: string | null
  /**
   * Email
   */
  email: string
  /**
   * Website
   */
  website?: string | null
  /**
   * Saleschannelid
   */
  salesChannelId?: string | null
}

/**
 * UpdateCustomerAddress
 *
 * Schema for updating a customer address.
 */
export type UpdateCustomerAddress = {
  /**
   * Countrycode
   */
  countryCode: string
  /**
   * Name
   */
  name: string
  /**
   * Nameext
   */
  nameExt?: string | null
  /**
   * Address
   */
  address: string
  /**
   * Address2
   */
  address2?: string | null
  /**
   * Address3
   */
  address3?: string | null
  /**
   * Postalcode
   */
  postalCode?: string | null
  /**
   * State
   */
  state?: string | null
  /**
   * City
   */
  city: string
  /**
   * Phone
   */
  phone?: string | null
  /**
   * Fax
   */
  fax?: string | null
  /**
   * Email
   */
  email?: string | null
  /**
   * Website
   */
  website?: string | null
  /**
   * Vatnumber
   */
  vatNumber?: string | null
}

/**
 * UpdateCustomerRelation
 *
 * Schema for updating a customer relation.
 */
export type UpdateCustomerRelation = {
  /**
   * Privatecountrycode
   */
  privateCountryCode: string
  /**
   * Name
   */
  name: string
  /**
   * Firstname
   */
  firstName?: string | null
  /**
   * Initials
   */
  initials: string
  genderCode?: GenderCode | null
  /**
   * Jobdescription
   */
  jobDescription?: string | null
  /**
   * Department
   */
  department?: string | null
  /**
   * Officephone
   */
  officePhone?: string | null
  /**
   * Officefax
   */
  officeFax?: string | null
  /**
   * Mobilephone
   */
  mobilePhone?: string | null
  /**
   * Email
   */
  email?: string | null
  /**
   * Subscribesalesquotcommtype
   */
  subscribeSalesQuotCommType?: number | null
  /**
   * Subscribeordconfcommtype
   */
  subscribeOrdConfCommType?: number | null
  /**
   * Subscribeshipdoccommtype
   */
  subscribeShipDocCommType?: number | null
  /**
   * Subscribesalesinvcommtype
   */
  subscribeSalesInvCommType?: number | null
  /**
   * Subscriberemindercommtype
   */
  subscribeReminderCommType?: number | null
}

/**
 * UpdateDoorListItem
 *
 * Schema for adding or updating a door list item.
 */
export type UpdateDoorListItem = {
  /**
   * Configuration
   */
  configuration: {
    [key: string]: SetDoorListValue
  }
  /**
   * Multiplier
   */
  multiplier: number
  /**
   * Name
   */
  name: string | null
}

/**
 * UpdateInvoiceAddress
 *
 * Schema for updating a customer invoice address.
 */
export type UpdateInvoiceAddress = {
  /**
   * Email
   */
  email: string
  /**
   * Nameext
   */
  nameExt?: string | null
}

/**
 * UpdateQuotation
 *
 * Update a quotation.
 */
export type UpdateQuotation = {
  /**
   * Relationid
   */
  relationId: string
  projectInformation: ProjectInformation
  costInformation: CostInformation
  deliveryConditions: DeliveryConditions
}

/**
 * UpdateSuborderDeliveryAddress
 *
 * Request schema for updating a suborder's delivery address.
 */
export type UpdateSuborderDeliveryAddress = {
  /**
   * Deliveryaddressid
   */
  deliveryAddressId: string
}

/**
 * UpdateSuborderTrackAndTrace
 *
 * Request schema for updating a suborder's track and trace setting.
 */
export type UpdateSuborderTrackAndTrace = {
  /**
   * Trackandtrace
   */
  trackAndTrace: boolean
}

/**
 * UserProfile
 *
 * OpenDoors user profile.
 */
export type UserProfile = {
  /**
   * Userid
   */
  userId: string
  /**
   * Email
   */
  email: string
  /**
   * Givenname
   */
  givenName: string
  /**
   * Familyname
   */
  familyName: string
  preferredLanguage: Language
  /**
   * Roles
   */
  roles: Array<Role>
}

/**
 * UserProfileUpdate
 *
 * Update user profile.
 */
export type UserProfileUpdate = {
  preferredLanguage: Language | null
}

/**
 * ValidateInvitationRequest
 *
 * Payload to validate a customer portal invitation token.
 */
export type ValidateInvitationRequest = {
  /**
   * Token
   *
   * Raw URL-safe invitation token
   */
  token: string
}

/**
 * ValidateInvitationResponse
 *
 * Validation response for a customer portal invitation token.
 */
export type ValidateInvitationResponse = {
  /**
   * Valid
   */
  valid?: true
  /**
   * Email
   */
  email: string
}

/**
 * ValidationConflict
 *
 * Configuration model validation error, feature conflicts with other feature(s).
 */
export type ValidationConflict = {
  /**
   * Id
   */
  id: string
  /**
   * Type
   */
  type?: 'selection'
  /**
   * Alternatives
   */
  alternatives: Array<string>
}

/**
 * ValidationError
 */
export type ValidationError = {
  /**
   * Location
   */
  loc: Array<string | number>
  /**
   * Message
   */
  msg: string
  /**
   * Error Type
   */
  type: string
  /**
   * Input
   */
  input?: unknown
  /**
   * Context
   */
  ctx?: {
    [key: string]: unknown
  }
}

/**
 * ValidationMissingFeature
 *
 * Configuration model validation error, feature not allowed.
 */
export type ValidationMissingFeature = {
  /**
   * Id
   */
  id: string
  /**
   * Type
   */
  type?: 'missing'
}

/**
 * ValidationValueError
 *
 * Configuration model value error.
 */
export type ValidationValueError = {
  /**
   * Id
   */
  id: string
  /**
   * Type
   */
  type?: 'value'
  valueRequested: FeatureValue
  valueActual: FeatureValue
}

/**
 * _AvailableRule
 */
export type AvailableRule = {
  /**
   * Featureid
   */
  featureId: string
  /**
   * Columnids
   */
  columnIds: Array<string>
}

/**
 * _RulesetPreview
 */
export type RulesetPreview = {
  /**
   * Configuration node ID
   */
  nodeId?: string | null
  /**
   * Columnids
   *
   * List of column IDs to preview
   */
  columnIds: Array<string>
  /**
   * Rules
   *
   * List of rules to apply
   */
  rules: Array<Rule>
}

/**
 * Config
 *
 * Authentication configuration.
 */
export type OpendoorsApiAuthSchemasConfig = {
  /**
   * Microsoft Entra ID configuration
   *
   * Microsoft Entra ID configuration.
   */
  entraId: EntraConfig
}

/**
 * Config
 *
 * Configuration values for frontend application.
 */
export type OpendoorsApiConfigSchemasConfig = {
  /**
   * AG Grid license key
   */
  agGridKey: string | null
}

/**
 * Customer
 *
 * Customer from CRM/ERP.
 */
export type OpendoorsApiCustomersSchemasCustomer = {
  /**
   * Id
   */
  id?: string | null
  /**
   * Name
   */
  name: string
  /**
   * Nameext
   */
  nameExt?: string | null
  /**
   * Address
   */
  address: string
  /**
   * Postalcode
   */
  postalCode: string
  /**
   * State
   */
  state: string
  /**
   * Countrycode
   */
  countryCode: string
  /**
   * City
   */
  city: string
  /**
   * Phone
   */
  phone?: string | null
  /**
   * Email
   */
  email: string
  /**
   * Lastmodified
   */
  lastModified?: Date | null
  /**
   * Lastmodifiedby
   */
  lastModifiedBy?: string | null
  /**
   * Lobcode
   */
  lobCode?: string | null
  /**
   * Saleschannelid
   */
  salesChannelId?: string | null
}

/**
 * CustomerRelation
 *
 * Customer relation schema.
 */
export type OpendoorsApiCustomersSchemasCustomerRelation = {
  /**
   * Custrelcode
   */
  custRelCode: string
  /**
   * Customerid
   */
  customerId?: string | null
  /**
   * Privatecountrycode
   */
  privateCountryCode?: string | null
  /**
   * Name
   */
  name: string
  /**
   * Firstname
   */
  firstName?: string | null
  /**
   * Initials
   */
  initials?: string | null
  genderCode?: GenderCode | null
  /**
   * Jobdescription
   */
  jobDescription?: string | null
  /**
   * Officephone
   */
  officePhone?: string | null
  /**
   * Officefax
   */
  officeFax?: string | null
  /**
   * Department
   */
  department?: string | null
  /**
   * Email
   */
  email?: string | null
  /**
   * Mobilephone
   */
  mobilePhone?: string | null
  /**
   * Subscribesalesquotcommtype
   */
  subscribeSalesQuotCommType?: number | null
  /**
   * Subscribeordconfcommtype
   */
  subscribeOrdConfCommType?: number | null
  /**
   * Subscribeshipdoccommtype
   */
  subscribeShipDocCommType?: number | null
  /**
   * Subscribesalesinvcommtype
   */
  subscribeSalesInvCommType?: number | null
  /**
   * Subscriberemindercommtype
   */
  subscribeReminderCommType?: number | null
  /**
   * Customerrelationobsind
   */
  customerRelationObsInd?: boolean | null
}

/**
 * Customer
 *
 * API view for order customers.
 */
export type OpendoorsApiOrdersSchemasCustomer = {
  /**
   * Id
   */
  id: string
  /**
   * Name
   */
  name: string
}

/**
 * CustomerRelation
 *
 * API view for order customers relations.
 */
export type OpendoorsApiOrdersSchemasCustomerRelation = {
  /**
   * Code
   */
  code: string
  /**
   * Name
   */
  name: string
}

/**
 * Customer
 *
 * OpenDoors quotation customer.
 */
export type OpendoorsApiQuotationsSchemasCustomer = {
  /**
   * Id
   */
  id: string
  address: Address
}

export type OpsHealthCheckData = {
  body?: never
  path?: never
  query?: never
  url: '/health'
}

export type OpsHealthCheckResponses = {
  /**
   * Successful Response
   */
  200: string
}

export type OpsHealthCheckResponse = OpsHealthCheckResponses[keyof OpsHealthCheckResponses]

export type OpsReadinessCheckData = {
  body?: never
  path?: never
  query?: never
  url: '/ready'
}

export type OpsReadinessCheckErrors = {
  /**
   * Service Unavailable
   */
  503: ReadinessReport
}

export type OpsReadinessCheckError = OpsReadinessCheckErrors[keyof OpsReadinessCheckErrors]

export type OpsReadinessCheckResponses = {
  /**
   * Successful Response
   */
  200: ReadinessReport
}

export type OpsReadinessCheckResponse = OpsReadinessCheckResponses[keyof OpsReadinessCheckResponses]

export type OpsGetCacheMetricsData = {
  body?: never
  path?: never
  query?: never
  url: '/metrics/cache'
}

export type OpsGetCacheMetricsResponses = {
  /**
   * Response Ops-Get Cache Metrics
   *
   * Successful Response
   */
  200: {
    [key: string]: CacheStats
  }
}

export type OpsGetCacheMetricsResponse =
  OpsGetCacheMetricsResponses[keyof OpsGetCacheMetricsResponses]

export type AuthConfigData = {
  body?: never
  path?: never
  query?: never
  url: '/auth/config'
}

export type AuthConfigResponses = {
  /**
   * Successful Response
   */
  200: OpendoorsApiAuthSchemasConfig
}

export type AuthConfigResponse = AuthConfigResponses[keyof AuthConfigResponses]

export type AuthCustomerPortalConfigData = {
  body?: never
  path?: never
  query?: never
  url: '/auth/cp-config'
}

export type AuthCustomerPortalConfigResponses = {
  /**
   * Successful Response
   */
  200: OpendoorsApiAuthSchemasConfig
}

export type AuthCustomerPortalConfigResponse =
  AuthCustomerPortalConfigResponses[keyof AuthCustomerPortalConfigResponses]

export type UserMeData = {
  body?: never
  path?: never
  query?: never
  url: '/v1/user/me'
}

export type UserMeResponses = {
  /**
   * Successful Response
   */
  200: UserProfile
}

export type UserMeResponse = UserMeResponses[keyof UserMeResponses]

export type UserUpdateProfileData = {
  body: UserProfileUpdate
  path?: never
  query?: never
  url: '/v1/user/me'
}

export type UserUpdateProfileErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type UserUpdateProfileError = UserUpdateProfileErrors[keyof UserUpdateProfileErrors]

export type UserUpdateProfileResponses = {
  /**
   * Successful Response
   */
  200: UserProfile
}

export type UserUpdateProfileResponse = UserUpdateProfileResponses[keyof UserUpdateProfileResponses]

export type QuotationsFindData = {
  body?: never
  path?: never
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
    /**
     * Customername
     *
     * Filter by customer name (partial match supported - e.g., first 3 letters)
     */
    customerName?: string | null
  }
  url: '/v1/quotations/'
}

export type QuotationsFindErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsFindError = QuotationsFindErrors[keyof QuotationsFindErrors]

export type QuotationsFindResponses = {
  /**
   * Successful Response
   */
  200: PageQuotationDetail
}

export type QuotationsFindResponse = QuotationsFindResponses[keyof QuotationsFindResponses]

export type QuotationsAddData = {
  body: AddQuotation
  path?: never
  query?: never
  url: '/v1/quotations/'
}

export type QuotationsAddErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsAddError = QuotationsAddErrors[keyof QuotationsAddErrors]

export type QuotationsAddResponses = {
  /**
   * Successful Response
   */
  200: QuotationId
}

export type QuotationsAddResponse = QuotationsAddResponses[keyof QuotationsAddResponses]

export type QuotationsGetData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}'
}

export type QuotationsGetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsGetError = QuotationsGetErrors[keyof QuotationsGetErrors]

export type QuotationsGetResponses = {
  /**
   * Successful Response
   */
  200: QuotationDetail
}

export type QuotationsGetResponse = QuotationsGetResponses[keyof QuotationsGetResponses]

export type QuotationsUpdateData = {
  body: UpdateQuotation
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}'
}

export type QuotationsUpdateErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsUpdateError = QuotationsUpdateErrors[keyof QuotationsUpdateErrors]

export type QuotationsUpdateResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type QuotationsToOrderData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/order'
}

export type QuotationsToOrderErrors = {
  /**
   * Response 400 Quotations-To Order
   *
   * Bad Request
   */
  400:
    | ({
        type: 'order_transform_error'
      } & OrderTransformErrorResponse)
    | ({
        type: 'create_quotation'
      } & CreateQuotationErrorResponse)
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsToOrderError = QuotationsToOrderErrors[keyof QuotationsToOrderErrors]

export type QuotationsToOrderResponses = {
  /**
   * Response Quotations-To Order
   *
   * Successful Response
   */
  200: string
}

export type QuotationsToOrderResponse = QuotationsToOrderResponses[keyof QuotationsToOrderResponses]

export type QuotationsGetUploadedFileData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/upload'
}

export type QuotationsGetUploadedFileErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsGetUploadedFileError =
  QuotationsGetUploadedFileErrors[keyof QuotationsGetUploadedFileErrors]

export type QuotationsGetUploadedFileResponses = {
  /**
   * Successful Response
   */
  200: ImportFile
}

export type QuotationsGetUploadedFileResponse =
  QuotationsGetUploadedFileResponses[keyof QuotationsGetUploadedFileResponses]

export type QuotationsUploadData = {
  body: BodyQuotationsUpload
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/upload'
}

export type QuotationsUploadErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsUploadError = QuotationsUploadErrors[keyof QuotationsUploadErrors]

export type QuotationsUploadResponses = {
  /**
   * Successful Response
   */
  200: ImportFile
}

export type QuotationsUploadResponse = QuotationsUploadResponses[keyof QuotationsUploadResponses]

export type QuotationsUpdateImportOptionsData = {
  body: ImportOptions
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/upload/options'
}

export type QuotationsUpdateImportOptionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsUpdateImportOptionsError =
  QuotationsUpdateImportOptionsErrors[keyof QuotationsUpdateImportOptionsErrors]

export type QuotationsUpdateImportOptionsResponses = {
  /**
   * Successful Response
   */
  200: ImportOptions
}

export type QuotationsUpdateImportOptionsResponse =
  QuotationsUpdateImportOptionsResponses[keyof QuotationsUpdateImportOptionsResponses]

export type QuotationsImportFileData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/upload/process'
}

export type QuotationsImportFileErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsImportFileError = QuotationsImportFileErrors[keyof QuotationsImportFileErrors]

export type QuotationsImportFileResponses = {
  /**
   * Successful Response
   */
  200: ImportTable
}

export type QuotationsImportFileResponse =
  QuotationsImportFileResponses[keyof QuotationsImportFileResponses]

export type QuotationsGetImportTableData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/table'
}

export type QuotationsGetImportTableErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsGetImportTableError =
  QuotationsGetImportTableErrors[keyof QuotationsGetImportTableErrors]

export type QuotationsGetImportTableResponses = {
  /**
   * Successful Response
   */
  200: ImportTable
}

export type QuotationsGetImportTableResponse =
  QuotationsGetImportTableResponses[keyof QuotationsGetImportTableResponses]

export type QuotationsSetColumnVisibilityData = {
  /**
   * State
   */
  body: Array<ColumnVisibility>
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/table/column-visibility'
}

export type QuotationsSetColumnVisibilityErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsSetColumnVisibilityError =
  QuotationsSetColumnVisibilityErrors[keyof QuotationsSetColumnVisibilityErrors]

export type QuotationsSetColumnVisibilityResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type QuotationsSetColumnVisibilityResponse =
  QuotationsSetColumnVisibilityResponses[keyof QuotationsSetColumnVisibilityResponses]

export type QuotationsGetRulesetsData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
    /**
     * Column
     *
     * Filter result on used column IDs
     */
    column?: Array<string> | null
    /**
     * Node
     *
     * Filter result on used node ID
     */
    node?: string | null
  }
  url: '/v1/quotations/{id}/import/ruleset'
}

export type QuotationsGetRulesetsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsGetRulesetsError =
  QuotationsGetRulesetsErrors[keyof QuotationsGetRulesetsErrors]

export type QuotationsGetRulesetsResponses = {
  /**
   * Successful Response
   */
  200: PageRuleSet
}

export type QuotationsGetRulesetsResponse =
  QuotationsGetRulesetsResponses[keyof QuotationsGetRulesetsResponses]

export type QuotationsAddRulesetData = {
  body: RuleSetChange
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/ruleset'
}

export type QuotationsAddRulesetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsAddRulesetError = QuotationsAddRulesetErrors[keyof QuotationsAddRulesetErrors]

export type QuotationsAddRulesetResponses = {
  /**
   * Successful Response
   */
  200: RuleSet
}

export type QuotationsAddRulesetResponse =
  QuotationsAddRulesetResponses[keyof QuotationsAddRulesetResponses]

export type QuotationsGetAvailableRulesData = {
  body: AvailableRule
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/available-rules'
}

export type QuotationsGetAvailableRulesErrors = {
  /**
   * Response 404 Quotations-Get Available Rules
   *
   * Not Found
   */
  404: string
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsGetAvailableRulesError =
  QuotationsGetAvailableRulesErrors[keyof QuotationsGetAvailableRulesErrors]

export type QuotationsGetAvailableRulesResponses = {
  /**
   * Response Quotations-Get Available Rules
   *
   * Successful Response
   */
  200: Array<RuleDefinition>
}

export type QuotationsGetAvailableRulesResponse =
  QuotationsGetAvailableRulesResponses[keyof QuotationsGetAvailableRulesResponses]

export type QuotationsRulesetPreviewData = {
  body: RulesetPreview
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/ruleset-preview'
}

export type QuotationsRulesetPreviewErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsRulesetPreviewError =
  QuotationsRulesetPreviewErrors[keyof QuotationsRulesetPreviewErrors]

export type QuotationsRulesetPreviewResponses = {
  /**
   * Successful Response
   */
  200: PreviewTable
}

export type QuotationsRulesetPreviewResponse =
  QuotationsRulesetPreviewResponses[keyof QuotationsRulesetPreviewResponses]

export type QuotationsRemoveRulesetData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
    /**
     * Rule set ID
     *
     * Import rule set identifier
     */
    ruleset_id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/ruleset/{ruleset_id}'
}

export type QuotationsRemoveRulesetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsRemoveRulesetError =
  QuotationsRemoveRulesetErrors[keyof QuotationsRemoveRulesetErrors]

export type QuotationsRemoveRulesetResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type QuotationsRemoveRulesetResponse =
  QuotationsRemoveRulesetResponses[keyof QuotationsRemoveRulesetResponses]

export type QuotationsUpdateRulesetData = {
  body: RuleSetChange
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
    /**
     * Rule set ID
     *
     * Import rule set identifier
     */
    ruleset_id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/ruleset/{ruleset_id}'
}

export type QuotationsUpdateRulesetErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsUpdateRulesetError =
  QuotationsUpdateRulesetErrors[keyof QuotationsUpdateRulesetErrors]

export type QuotationsUpdateRulesetResponses = {
  /**
   * Successful Response
   */
  200: RuleSet
}

export type QuotationsUpdateRulesetResponse =
  QuotationsUpdateRulesetResponses[keyof QuotationsUpdateRulesetResponses]

export type QuotationsMostUsedFeaturesData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/most-used-features'
}

export type QuotationsMostUsedFeaturesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsMostUsedFeaturesError =
  QuotationsMostUsedFeaturesErrors[keyof QuotationsMostUsedFeaturesErrors]

export type QuotationsMostUsedFeaturesResponses = {
  /**
   * Response Quotations-Most Used Features
   *
   * Successful Response
   */
  200: Array<MostUsedFeature>
}

export type QuotationsMostUsedFeaturesResponse =
  QuotationsMostUsedFeaturesResponses[keyof QuotationsMostUsedFeaturesResponses]

export type QuotationsValidateRowData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
    /**
     * Row ID
     *
     * Import table row identifier
     */
    row: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/validate/{row}'
}

export type QuotationsValidateRowErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsValidateRowError =
  QuotationsValidateRowErrors[keyof QuotationsValidateRowErrors]

export type QuotationsValidateRowResponses = {
  /**
   * Successful Response
   */
  200: RowValidation
}

export type QuotationsValidateRowResponse =
  QuotationsValidateRowResponses[keyof QuotationsValidateRowResponses]

export type QuotationsToDoorListData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/import/to-doorlist'
}

export type QuotationsToDoorListErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsToDoorListError = QuotationsToDoorListErrors[keyof QuotationsToDoorListErrors]

export type QuotationsToDoorListResponses = {
  /**
   * Successful Response
   */
  200: DoorListTree
}

export type QuotationsToDoorListResponse =
  QuotationsToDoorListResponses[keyof QuotationsToDoorListResponses]

export type QuotationsGetDoorListData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/doorlist/'
}

export type QuotationsGetDoorListErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsGetDoorListError =
  QuotationsGetDoorListErrors[keyof QuotationsGetDoorListErrors]

export type QuotationsGetDoorListResponses = {
  /**
   * Successful Response
   */
  200: DoorListTree
}

export type QuotationsGetDoorListResponse =
  QuotationsGetDoorListResponses[keyof QuotationsGetDoorListResponses]

export type QuotationsAddDoorListItemData = {
  body: UpdateDoorListItem
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/doorlist/items'
}

export type QuotationsAddDoorListItemErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsAddDoorListItemError =
  QuotationsAddDoorListItemErrors[keyof QuotationsAddDoorListItemErrors]

export type QuotationsAddDoorListItemResponses = {
  /**
   * Successful Response
   */
  200: DoorListItem
}

export type QuotationsAddDoorListItemResponse =
  QuotationsAddDoorListItemResponses[keyof QuotationsAddDoorListItemResponses]

export type QuotationsBulkUpdateDoorListItemsData = {
  /**
   * Items
   */
  body: {
    [key: string]: UpdateDoorListItem
  }
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/doorlist/items/bulk'
}

export type QuotationsBulkUpdateDoorListItemsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsBulkUpdateDoorListItemsError =
  QuotationsBulkUpdateDoorListItemsErrors[keyof QuotationsBulkUpdateDoorListItemsErrors]

export type QuotationsBulkUpdateDoorListItemsResponses = {
  /**
   * Response Quotations-Bulk Update Door List Items
   *
   * Successful Response
   */
  200: {
    [key: string]: DoorListItem
  }
}

export type QuotationsBulkUpdateDoorListItemsResponse =
  QuotationsBulkUpdateDoorListItemsResponses[keyof QuotationsBulkUpdateDoorListItemsResponses]

export type QuotationsBulkDeleteDoorListItemsData = {
  /**
   * Item Ids
   */
  body: Array<string>
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
  }
  query?: never
  url: '/v1/quotations/{id}/doorlist/items/bulk-delete'
}

export type QuotationsBulkDeleteDoorListItemsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsBulkDeleteDoorListItemsError =
  QuotationsBulkDeleteDoorListItemsErrors[keyof QuotationsBulkDeleteDoorListItemsErrors]

export type QuotationsBulkDeleteDoorListItemsResponses = {
  /**
   * Successful Response
   */
  200: DeleteCount
}

export type QuotationsBulkDeleteDoorListItemsResponse =
  QuotationsBulkDeleteDoorListItemsResponses[keyof QuotationsBulkDeleteDoorListItemsResponses]

export type QuotationsRemoveDoorListItemData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
    /**
     * Door list item ID
     *
     * Door list line item identifier
     */
    item_id: string
  }
  query?: never
  url: '/v1/quotations/{id}/doorlist/items/{item_id}'
}

export type QuotationsRemoveDoorListItemErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsRemoveDoorListItemError =
  QuotationsRemoveDoorListItemErrors[keyof QuotationsRemoveDoorListItemErrors]

export type QuotationsRemoveDoorListItemResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type QuotationsUpdateDoorListItemData = {
  body: UpdateDoorListItem
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
    /**
     * Door list item ID
     *
     * Door list line item identifier
     */
    item_id: string
  }
  query?: never
  url: '/v1/quotations/{id}/doorlist/items/{item_id}'
}

export type QuotationsUpdateDoorListItemErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsUpdateDoorListItemError =
  QuotationsUpdateDoorListItemErrors[keyof QuotationsUpdateDoorListItemErrors]

export type QuotationsUpdateDoorListItemResponses = {
  /**
   * Successful Response
   */
  200: DoorListItem
}

export type QuotationsUpdateDoorListItemResponse =
  QuotationsUpdateDoorListItemResponses[keyof QuotationsUpdateDoorListItemResponses]

export type QuotationsValidateDoorListItemData = {
  body?: never
  path: {
    /**
     * Quotation ID
     *
     * Quotation identifier
     */
    id: string
    /**
     * Door list item ID
     *
     * Door list line item identifier
     */
    item_id: string
  }
  query?: never
  url: '/v1/quotations/{id}/doorlist/items/{item_id}/validate'
}

export type QuotationsValidateDoorListItemErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type QuotationsValidateDoorListItemError =
  QuotationsValidateDoorListItemErrors[keyof QuotationsValidateDoorListItemErrors]

export type QuotationsValidateDoorListItemResponses = {
  /**
   * Successful Response
   */
  200: ItemValidation
}

export type QuotationsValidateDoorListItemResponse =
  QuotationsValidateDoorListItemResponses[keyof QuotationsValidateDoorListItemResponses]

export type CustomersFindCustomersData = {
  body?: never
  path?: never
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
    /**
     * Searchid
     *
     * Filter ID contains value
     */
    searchId?: string | null
    /**
     * Searchname
     *
     * Filter name contains value
     */
    searchName?: string | null
  }
  url: '/v1/customers/'
}

export type CustomersFindCustomersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersFindCustomersError =
  CustomersFindCustomersErrors[keyof CustomersFindCustomersErrors]

export type CustomersFindCustomersResponses = {
  /**
   * Successful Response
   */
  200: PageCustomer
}

export type CustomersFindCustomersResponse =
  CustomersFindCustomersResponses[keyof CustomersFindCustomersResponses]

export type CustomersGetCustomerRelaionsQuoteData = {
  body?: never
  path?: never
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
    /**
     * Searchname
     *
     * Filter name contains value
     */
    searchName?: string | null
  }
  url: '/v1/customers/relations'
}

export type CustomersGetCustomerRelaionsQuoteErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersGetCustomerRelaionsQuoteError =
  CustomersGetCustomerRelaionsQuoteErrors[keyof CustomersGetCustomerRelaionsQuoteErrors]

export type CustomersGetCustomerRelaionsQuoteResponses = {
  /**
   * Successful Response
   */
  200: PageCustomerRelationQuotationList
}

export type CustomersGetCustomerRelaionsQuoteResponse =
  CustomersGetCustomerRelaionsQuoteResponses[keyof CustomersGetCustomerRelaionsQuoteResponses]

export type CustomersGetCustomerData = {
  body?: never
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}'
}

export type CustomersGetCustomerErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersGetCustomerError = CustomersGetCustomerErrors[keyof CustomersGetCustomerErrors]

export type CustomersGetCustomerResponses = {
  /**
   * Successful Response
   */
  200: CustomerDetail
}

export type CustomersGetCustomerResponse =
  CustomersGetCustomerResponses[keyof CustomersGetCustomerResponses]

export type CustomersUpdateCustomerData = {
  body: UpdateCustomer
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}'
}

export type CustomersUpdateCustomerErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersUpdateCustomerError =
  CustomersUpdateCustomerErrors[keyof CustomersUpdateCustomerErrors]

export type CustomersUpdateCustomerResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type CustomersGetCustomerAddressesData = {
  body?: never
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
  }
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
  }
  url: '/v1/customers/{customer_id}/addresses'
}

export type CustomersGetCustomerAddressesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersGetCustomerAddressesError =
  CustomersGetCustomerAddressesErrors[keyof CustomersGetCustomerAddressesErrors]

export type CustomersGetCustomerAddressesResponses = {
  /**
   * Successful Response
   */
  200: PageCustomerAddress
}

export type CustomersGetCustomerAddressesResponse =
  CustomersGetCustomerAddressesResponses[keyof CustomersGetCustomerAddressesResponses]

export type CustomersCreateCustomerAddressData = {
  body: CreateCustomerAddress
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}/addresses'
}

export type CustomersCreateCustomerAddressErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersCreateCustomerAddressError =
  CustomersCreateCustomerAddressErrors[keyof CustomersCreateCustomerAddressErrors]

export type CustomersCreateCustomerAddressResponses = {
  /**
   * Successful Response
   */
  200: CustomerAddressResponse
}

export type CustomersCreateCustomerAddressResponse =
  CustomersCreateCustomerAddressResponses[keyof CustomersCreateCustomerAddressResponses]

export type CustomersDeleteCustomerAddressData = {
  body?: never
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
    /**
     * Customer address ID
     *
     * Customer address identifier
     */
    address_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}/addresses/{address_id}'
}

export type CustomersDeleteCustomerAddressErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersDeleteCustomerAddressError =
  CustomersDeleteCustomerAddressErrors[keyof CustomersDeleteCustomerAddressErrors]

export type CustomersDeleteCustomerAddressResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type CustomersGetCustomerAddressData = {
  body?: never
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
    /**
     * Customer address ID
     *
     * Customer address identifier
     */
    address_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}/addresses/{address_id}'
}

export type CustomersGetCustomerAddressErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersGetCustomerAddressError =
  CustomersGetCustomerAddressErrors[keyof CustomersGetCustomerAddressErrors]

export type CustomersGetCustomerAddressResponses = {
  /**
   * Successful Response
   */
  200: CustomerAddress
}

export type CustomersGetCustomerAddressResponse =
  CustomersGetCustomerAddressResponses[keyof CustomersGetCustomerAddressResponses]

export type CustomersUpdateCustomerAddressData = {
  body: UpdateCustomerAddress
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
    /**
     * Customer address ID
     *
     * Customer address identifier
     */
    address_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}/addresses/{address_id}'
}

export type CustomersUpdateCustomerAddressErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersUpdateCustomerAddressError =
  CustomersUpdateCustomerAddressErrors[keyof CustomersUpdateCustomerAddressErrors]

export type CustomersUpdateCustomerAddressResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type CustomersGetCustomerRelationsData = {
  body?: never
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
  }
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
    /**
     * Searchname
     *
     * Filter name contains value
     */
    searchName?: string | null
  }
  url: '/v1/customers/{customer_id}/relations'
}

export type CustomersGetCustomerRelationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersGetCustomerRelationsError =
  CustomersGetCustomerRelationsErrors[keyof CustomersGetCustomerRelationsErrors]

export type CustomersGetCustomerRelationsResponses = {
  /**
   * Successful Response
   */
  200: PageCustomerRelation
}

export type CustomersGetCustomerRelationsResponse =
  CustomersGetCustomerRelationsResponses[keyof CustomersGetCustomerRelationsResponses]

export type CustomersCreateCustomerRelationData = {
  body: CreateCustomerRelation
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}/relations'
}

export type CustomersCreateCustomerRelationErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersCreateCustomerRelationError =
  CustomersCreateCustomerRelationErrors[keyof CustomersCreateCustomerRelationErrors]

export type CustomersCreateCustomerRelationResponses = {
  /**
   * Successful Response
   */
  200: CustomerRelationResponse
}

export type CustomersCreateCustomerRelationResponse =
  CustomersCreateCustomerRelationResponses[keyof CustomersCreateCustomerRelationResponses]

export type CustomersDeleteCustomerRelationData = {
  body?: never
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
    /**
     * Customer relation ID
     *
     * Customer relation identifier
     */
    relation_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}/relations/{relation_id}'
}

export type CustomersDeleteCustomerRelationErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersDeleteCustomerRelationError =
  CustomersDeleteCustomerRelationErrors[keyof CustomersDeleteCustomerRelationErrors]

export type CustomersDeleteCustomerRelationResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type CustomersGetCustomerRelationData = {
  body?: never
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
    /**
     * Customer relation ID
     *
     * Customer relation identifier
     */
    relation_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}/relations/{relation_id}'
}

export type CustomersGetCustomerRelationErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersGetCustomerRelationError =
  CustomersGetCustomerRelationErrors[keyof CustomersGetCustomerRelationErrors]

export type CustomersGetCustomerRelationResponses = {
  /**
   * Successful Response
   */
  200: OpendoorsApiCustomersSchemasCustomerRelation
}

export type CustomersGetCustomerRelationResponse =
  CustomersGetCustomerRelationResponses[keyof CustomersGetCustomerRelationResponses]

export type CustomersUpdateCustomerRelationData = {
  body: UpdateCustomerRelation
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
    /**
     * Customer relation ID
     *
     * Customer relation identifier
     */
    relation_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}/relations/{relation_id}'
}

export type CustomersUpdateCustomerRelationErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersUpdateCustomerRelationError =
  CustomersUpdateCustomerRelationErrors[keyof CustomersUpdateCustomerRelationErrors]

export type CustomersUpdateCustomerRelationResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type CustomersGetInvoiceAddressData = {
  body?: never
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}/invoice-address'
}

export type CustomersGetInvoiceAddressErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersGetInvoiceAddressError =
  CustomersGetInvoiceAddressErrors[keyof CustomersGetInvoiceAddressErrors]

export type CustomersGetInvoiceAddressResponses = {
  /**
   * Successful Response
   */
  200: InvoiceAddress
}

export type CustomersGetInvoiceAddressResponse =
  CustomersGetInvoiceAddressResponses[keyof CustomersGetInvoiceAddressResponses]

export type CustomersCreateInvoiceAddressData = {
  body: CreateInvoiceAddress
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}/invoice-address'
}

export type CustomersCreateInvoiceAddressErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersCreateInvoiceAddressError =
  CustomersCreateInvoiceAddressErrors[keyof CustomersCreateInvoiceAddressErrors]

export type CustomersCreateInvoiceAddressResponses = {
  /**
   * Successful Response
   */
  200: CustomerAddressResponse
}

export type CustomersCreateInvoiceAddressResponse =
  CustomersCreateInvoiceAddressResponses[keyof CustomersCreateInvoiceAddressResponses]

export type CustomersUpdateInvoiceAddressData = {
  body: UpdateInvoiceAddress
  path: {
    /**
     * Customer ID
     *
     * Customer identifier
     */
    customer_id: string
  }
  query?: never
  url: '/v1/customers/{customer_id}/invoice-address'
}

export type CustomersUpdateInvoiceAddressErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersUpdateInvoiceAddressError =
  CustomersUpdateInvoiceAddressErrors[keyof CustomersUpdateInvoiceAddressErrors]

export type CustomersUpdateInvoiceAddressResponses = {
  /**
   * Successful Response
   */
  200: unknown
}

export type CustomersGetSalesChannelsData = {
  body?: never
  path?: never
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
  }
  url: '/v1/customers/lists/sales-channels'
}

export type CustomersGetSalesChannelsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomersGetSalesChannelsError =
  CustomersGetSalesChannelsErrors[keyof CustomersGetSalesChannelsErrors]

export type CustomersGetSalesChannelsResponses = {
  /**
   * Successful Response
   */
  200: PageSalesChannel
}

export type CustomersGetSalesChannelsResponse =
  CustomersGetSalesChannelsResponses[keyof CustomersGetSalesChannelsResponses]

export type CustomersGetLanguageCodesData = {
  body?: never
  path?: never
  query?: never
  url: '/v1/customers/lists/language-codes'
}

export type CustomersGetLanguageCodesResponses = {
  /**
   * Response Customers-Get Language Codes
   *
   * Successful Response
   */
  200: Array<LanguageCodes>
}

export type CustomersGetLanguageCodesResponse =
  CustomersGetLanguageCodesResponses[keyof CustomersGetLanguageCodesResponses]

export type CustomersGetCountryCodesData = {
  body?: never
  path?: never
  query?: never
  url: '/v1/customers/lists/country-codes'
}

export type CustomersGetCountryCodesResponses = {
  /**
   * Response Customers-Get Country Codes
   *
   * Successful Response
   */
  200: Array<CountryCodes>
}

export type CustomersGetCountryCodesResponse =
  CustomersGetCountryCodesResponses[keyof CustomersGetCountryCodesResponses]

export type CustomersGetCustomerGroupsData = {
  body?: never
  path?: never
  query?: never
  url: '/v1/customers/lists/customer-groups'
}

export type CustomersGetCustomerGroupsResponses = {
  /**
   * Response Customers-Get Customer Groups
   *
   * Successful Response
   */
  200: Array<CustomerGroups>
}

export type CustomersGetCustomerGroupsResponse =
  CustomersGetCustomerGroupsResponses[keyof CustomersGetCustomerGroupsResponses]

export type CustomersGetCurrencyCodesData = {
  body?: never
  path?: never
  query?: never
  url: '/v1/customers/lists/currency-codes'
}

export type CustomersGetCurrencyCodesResponses = {
  /**
   * Response Customers-Get Currency Codes
   *
   * Successful Response
   */
  200: Array<CurrencyCodes>
}

export type CustomersGetCurrencyCodesResponse =
  CustomersGetCurrencyCodesResponses[keyof CustomersGetCurrencyCodesResponses]

export type CustomersGetLobCodesData = {
  body?: never
  path?: never
  query?: never
  url: '/v1/customers/lists/lob-codes'
}

export type CustomersGetLobCodesResponses = {
  /**
   * Response Customers-Get Lob Codes
   *
   * Successful Response
   */
  200: Array<LobCodes>
}

export type CustomersGetLobCodesResponse =
  CustomersGetLobCodesResponses[keyof CustomersGetLobCodesResponses]

export type OrdersGetCustomerOrdersData = {
  body?: never
  path?: never
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
    /**
     * Orderreference
     *
     * Filter by order reference
     */
    orderReference?: string | null
    /**
     * Ordernumber
     *
     * Filter by order number
     */
    orderNumber?: string | null
    /**
     * Projectdescription
     *
     * Filter by project description
     */
    projectDescription?: string | null
    /**
     * Statuscode
     *
     * Filter by sales status. Can specify multiple status codes.
     */
    statusCode?: Array<string> | null
    /**
     * Deliveryweek
     *
     * Filter by delivery week
     */
    deliveryWeek?: string | null
    /**
     * Deliveryaddress
     *
     * Filter by delivery address
     */
    deliveryAddress?: string | null
    /**
     * Deliverymaincode
     *
     * Filter by delivery address
     */
    deliveryMainCode?: string | null
  }
  url: '/v1/orders/views/customer'
}

export type OrdersGetCustomerOrdersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type OrdersGetCustomerOrdersError =
  OrdersGetCustomerOrdersErrors[keyof OrdersGetCustomerOrdersErrors]

export type OrdersGetCustomerOrdersResponses = {
  /**
   * Successful Response
   */
  200: PageCustomerOrderView
}

export type OrdersGetCustomerOrdersResponse =
  OrdersGetCustomerOrdersResponses[keyof OrdersGetCustomerOrdersResponses]

export type OrdersGetOrderStatusesData = {
  body?: never
  path?: never
  query?: never
  url: '/v1/orders/lists/order-statuses'
}

export type OrdersGetOrderStatusesResponses = {
  /**
   * Response Orders-Get Order Statuses
   *
   * Successful Response
   */
  200: Array<OrderStatus>
}

export type OrdersGetOrderStatusesResponse =
  OrdersGetOrderStatusesResponses[keyof OrdersGetOrderStatusesResponses]

export type OrdersGetOrdersData = {
  body?: never
  path?: never
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
  }
  url: '/v1/orders'
}

export type OrdersGetOrdersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type OrdersGetOrdersError = OrdersGetOrdersErrors[keyof OrdersGetOrdersErrors]

export type OrdersGetOrdersResponses = {
  /**
   * Successful Response
   */
  200: PageOrderView
}

export type OrdersGetOrdersResponse = OrdersGetOrdersResponses[keyof OrdersGetOrdersResponses]

export type OrdersGetOrderDetailData = {
  body?: never
  path: {
    /**
     * Customer Id
     */
    customer_id: number
    /**
     * Order Id
     */
    order_id: number
  }
  query?: never
  url: '/v1/orders/{customer_id}/{order_id}'
}

export type OrdersGetOrderDetailErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type OrdersGetOrderDetailError = OrdersGetOrderDetailErrors[keyof OrdersGetOrderDetailErrors]

export type OrdersGetOrderDetailResponses = {
  /**
   * Successful Response
   */
  200: OrderDetailView
}

export type OrdersGetOrderDetailResponse =
  OrdersGetOrderDetailResponses[keyof OrdersGetOrderDetailResponses]

export type ConfigConfigData = {
  body?: never
  path?: never
  query?: never
  url: '/v1/config/'
}

export type ConfigConfigResponses = {
  /**
   * Successful Response
   */
  200: OpendoorsApiConfigSchemasConfig
}

export type ConfigConfigResponse = ConfigConfigResponses[keyof ConfigConfigResponses]

export type ConfigurationFeatureTreeData = {
  body?: never
  path?: never
  query?: never
  url: '/v1/configuration/feature-tree'
}

export type ConfigurationFeatureTreeResponses = {
  /**
   * Successful Response
   */
  200: ConfigurationTree
}

export type ConfigurationFeatureTreeResponse =
  ConfigurationFeatureTreeResponses[keyof ConfigurationFeatureTreeResponses]

export type AdminCreateCustomerInvitationData = {
  body: CreateCustomerInvitation
  path?: never
  query?: never
  url: '/v1/admin/invitations'
}

export type AdminCreateCustomerInvitationErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type AdminCreateCustomerInvitationError =
  AdminCreateCustomerInvitationErrors[keyof AdminCreateCustomerInvitationErrors]

export type AdminCreateCustomerInvitationResponses = {
  /**
   * Successful Response
   */
  200: CustomerInvitationResponse
}

export type AdminCreateCustomerInvitationResponse =
  AdminCreateCustomerInvitationResponses[keyof AdminCreateCustomerInvitationResponses]

export type AdminCreateCustomerRelationInvitationData = {
  body: CreateCustomerRelationInvitation
  path?: never
  query?: never
  url: '/v1/admin/invitations/customer-relation'
}

export type AdminCreateCustomerRelationInvitationErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type AdminCreateCustomerRelationInvitationError =
  AdminCreateCustomerRelationInvitationErrors[keyof AdminCreateCustomerRelationInvitationErrors]

export type AdminCreateCustomerRelationInvitationResponses = {
  /**
   * Successful Response
   */
  200: CustomerInvitationResponse
}

export type AdminCreateCustomerRelationInvitationResponse =
  AdminCreateCustomerRelationInvitationResponses[keyof AdminCreateCustomerRelationInvitationResponses]

export type AdminRevokeCustomerInvitationData = {
  body?: never
  path: {
    /**
     * Invitation Id
     */
    invitation_id: string
  }
  query?: never
  url: '/v1/admin/invitations/{invitation_id}/revoke'
}

export type AdminRevokeCustomerInvitationErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type AdminRevokeCustomerInvitationError =
  AdminRevokeCustomerInvitationErrors[keyof AdminRevokeCustomerInvitationErrors]

export type AdminRevokeCustomerInvitationResponses = {
  /**
   * Successful Response
   */
  200: CustomerInvitationResponse
}

export type AdminRevokeCustomerInvitationResponse =
  AdminRevokeCustomerInvitationResponses[keyof AdminRevokeCustomerInvitationResponses]

export type AdminListCustomerPortalUsersData = {
  body?: never
  path?: never
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
    /**
     * Customerid
     *
     * Filter by exact external customer identifier
     */
    customerId?: string | null
    /**
     * Relationid
     *
     * Filter by exact customer relation identifier
     */
    relationId?: string | null
    /**
     * Invitationstatus
     *
     * Filter by effective invitation status; EXPIRED matches pending invitations past expiry. Accounts without invitation never match.
     */
    invitationStatus?: InvitationStatus | null
  }
  url: '/v1/admin/customer-portal-users'
}

export type AdminListCustomerPortalUsersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type AdminListCustomerPortalUsersError =
  AdminListCustomerPortalUsersErrors[keyof AdminListCustomerPortalUsersErrors]

export type AdminListCustomerPortalUsersResponses = {
  /**
   * Successful Response
   */
  200: PageCustomerPortalUserResponse
}

export type AdminListCustomerPortalUsersResponse =
  AdminListCustomerPortalUsersResponses[keyof AdminListCustomerPortalUsersResponses]

export type AdminListCustomerPortalUserGroupsData = {
  body?: never
  path?: never
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
  }
  url: '/v1/admin/customer-portal-users/by-customer'
}

export type AdminListCustomerPortalUserGroupsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type AdminListCustomerPortalUserGroupsError =
  AdminListCustomerPortalUserGroupsErrors[keyof AdminListCustomerPortalUserGroupsErrors]

export type AdminListCustomerPortalUserGroupsResponses = {
  /**
   * Successful Response
   */
  200: PageCustomerPortalUserGroupResponse
}

export type AdminListCustomerPortalUserGroupsResponse =
  AdminListCustomerPortalUserGroupsResponses[keyof AdminListCustomerPortalUserGroupsResponses]

export type AdminDeleteCustomerPortalUserData = {
  body?: never
  path: {
    /**
     * Account Id
     */
    account_id: string
  }
  query?: never
  url: '/v1/admin/customer-portal-users/{account_id}'
}

export type AdminDeleteCustomerPortalUserErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type AdminDeleteCustomerPortalUserError =
  AdminDeleteCustomerPortalUserErrors[keyof AdminDeleteCustomerPortalUserErrors]

export type AdminDeleteCustomerPortalUserResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type AdminDeleteCustomerPortalUserResponse =
  AdminDeleteCustomerPortalUserResponses[keyof AdminDeleteCustomerPortalUserResponses]

export type CustomerPortalGetCustomerAddressesData = {
  body?: never
  path?: never
  query?: {
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number | null
    /**
     * I
     *
     * Starting index in the full result list.
     */
    i?: number | null
  }
  url: '/cp/addresses'
}

export type CustomerPortalGetCustomerAddressesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomerPortalGetCustomerAddressesError =
  CustomerPortalGetCustomerAddressesErrors[keyof CustomerPortalGetCustomerAddressesErrors]

export type CustomerPortalGetCustomerAddressesResponses = {
  /**
   * Successful Response
   */
  200: PageCustomerAddress
}

export type CustomerPortalGetCustomerAddressesResponse =
  CustomerPortalGetCustomerAddressesResponses[keyof CustomerPortalGetCustomerAddressesResponses]

export type CustomerPortalGetCustomerAddressData = {
  body?: never
  path: {
    /**
     * Customer address ID
     *
     * Customer address identifier
     */
    address_id: string
  }
  query?: never
  url: '/cp/addresses/{address_id}'
}

export type CustomerPortalGetCustomerAddressErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomerPortalGetCustomerAddressError =
  CustomerPortalGetCustomerAddressErrors[keyof CustomerPortalGetCustomerAddressErrors]

export type CustomerPortalGetCustomerAddressResponses = {
  /**
   * Successful Response
   */
  200: CustomerAddress
}

export type CustomerPortalGetCustomerAddressResponse =
  CustomerPortalGetCustomerAddressResponses[keyof CustomerPortalGetCustomerAddressResponses]

export type CustomerPortalMeData = {
  body?: never
  path?: never
  query?: never
  url: '/cp/me'
}

export type CustomerPortalMeResponses = {
  /**
   * Successful Response
   */
  200: UserProfile
}

export type CustomerPortalMeResponse = CustomerPortalMeResponses[keyof CustomerPortalMeResponses]

export type CustomerPortalGetCombinedCustomerOrdersData = {
  body?: never
  path?: never
  query?: {
    /**
     * Cursor
     *
     * Opaque cursor for the next page of results.
     */
    cursor?: string | null
    /**
     * Size
     *
     * Number of items per page.
     */
    size?: number
    /**
     * Searchterm
     *
     * Filter by free-text search term.
     */
    searchTerm?: string | null
    /**
     * Statuscode
     *
     * Filter by project status.
     */
    statusCode?: ProjectStatus | null
  }
  url: '/cp/views/customer/combined'
}

export type CustomerPortalGetCombinedCustomerOrdersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomerPortalGetCombinedCustomerOrdersError =
  CustomerPortalGetCombinedCustomerOrdersErrors[keyof CustomerPortalGetCombinedCustomerOrdersErrors]

export type CustomerPortalGetCombinedCustomerOrdersResponses = {
  /**
   * Successful Response
   */
  200: CombinedOrderPage
}

export type CustomerPortalGetCombinedCustomerOrdersResponse =
  CustomerPortalGetCombinedCustomerOrdersResponses[keyof CustomerPortalGetCombinedCustomerOrdersResponses]

export type CustomerPortalGetProjectsOverviewData = {
  body?: never
  path?: never
  query?: never
  url: '/cp/views/customer/door-sales-summary'
}

export type CustomerPortalGetProjectsOverviewResponses = {
  /**
   * Successful Response
   */
  200: DoorSalesSummary
}

export type CustomerPortalGetProjectsOverviewResponse =
  CustomerPortalGetProjectsOverviewResponses[keyof CustomerPortalGetProjectsOverviewResponses]

export type CustomerPortalGetHistoricalOrderDetailData = {
  body?: never
  path: {
    /**
     * Project Number
     */
    project_number: string
  }
  query?: never
  url: '/cp/views/customer/historical/{project_number}'
}

export type CustomerPortalGetHistoricalOrderDetailErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomerPortalGetHistoricalOrderDetailError =
  CustomerPortalGetHistoricalOrderDetailErrors[keyof CustomerPortalGetHistoricalOrderDetailErrors]

export type CustomerPortalGetHistoricalOrderDetailResponses = {
  /**
   * Successful Response
   */
  200: HistoricalOrderDetailView
}

export type CustomerPortalGetHistoricalOrderDetailResponse =
  CustomerPortalGetHistoricalOrderDetailResponses[keyof CustomerPortalGetHistoricalOrderDetailResponses]

export type CustomerPortalPatchSuborderDeliveryAddressData = {
  body: PatchSuborderDeliveryAddress
  path: {
    /**
     * Project Number
     */
    project_number: string
    /**
     * Order Number
     */
    order_number: string
  }
  query?: never
  url: '/cp/projects/{project_number}/suborders/{order_number}/delivery-address'
}

export type CustomerPortalPatchSuborderDeliveryAddressErrors = {
  /**
   * Bad Request
   */
  400: InvalidDeliveryAddressErrorResponse
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomerPortalPatchSuborderDeliveryAddressError =
  CustomerPortalPatchSuborderDeliveryAddressErrors[keyof CustomerPortalPatchSuborderDeliveryAddressErrors]

export type CustomerPortalPatchSuborderDeliveryAddressResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type CustomerPortalPatchSuborderDeliveryAddressResponse =
  CustomerPortalPatchSuborderDeliveryAddressResponses[keyof CustomerPortalPatchSuborderDeliveryAddressResponses]

export type CustomerPortalUpdateSuborderDeliveryAddressData = {
  body: UpdateSuborderDeliveryAddress
  path: {
    /**
     * Project Number
     */
    project_number: string
    /**
     * Order Number
     */
    order_number: string
  }
  query?: never
  url: '/cp/projects/{project_number}/suborders/{order_number}/delivery-address'
}

export type CustomerPortalUpdateSuborderDeliveryAddressErrors = {
  /**
   * Bad Request
   */
  400: InvalidDeliveryAddressErrorResponse
  /**
   * Conflict
   */
  409: DeliveryAddressChangeWindowClosedErrorResponse
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomerPortalUpdateSuborderDeliveryAddressError =
  CustomerPortalUpdateSuborderDeliveryAddressErrors[keyof CustomerPortalUpdateSuborderDeliveryAddressErrors]

export type CustomerPortalUpdateSuborderDeliveryAddressResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type CustomerPortalUpdateSuborderDeliveryAddressResponse =
  CustomerPortalUpdateSuborderDeliveryAddressResponses[keyof CustomerPortalUpdateSuborderDeliveryAddressResponses]

export type CustomerPortalGetSuborderTrackAndTraceData = {
  body?: never
  path: {
    /**
     * Project Number
     */
    project_number: string
    /**
     * Order Number
     */
    order_number: string
  }
  query?: never
  url: '/cp/projects/{project_number}/suborders/{order_number}/track-and-trace'
}

export type CustomerPortalGetSuborderTrackAndTraceErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomerPortalGetSuborderTrackAndTraceError =
  CustomerPortalGetSuborderTrackAndTraceErrors[keyof CustomerPortalGetSuborderTrackAndTraceErrors]

export type CustomerPortalGetSuborderTrackAndTraceResponses = {
  /**
   * Successful Response
   */
  200: SuborderTrackAndTraceView
}

export type CustomerPortalGetSuborderTrackAndTraceResponse =
  CustomerPortalGetSuborderTrackAndTraceResponses[keyof CustomerPortalGetSuborderTrackAndTraceResponses]

export type CustomerPortalUpdateSuborderTrackAndTraceData = {
  body: UpdateSuborderTrackAndTrace
  path: {
    /**
     * Project Number
     */
    project_number: string
    /**
     * Order Number
     */
    order_number: string
  }
  query?: never
  url: '/cp/projects/{project_number}/suborders/{order_number}/track-and-trace'
}

export type CustomerPortalUpdateSuborderTrackAndTraceErrors = {
  /**
   * Bad Request
   */
  400: InvalidDeliveryAddressErrorResponse
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomerPortalUpdateSuborderTrackAndTraceError =
  CustomerPortalUpdateSuborderTrackAndTraceErrors[keyof CustomerPortalUpdateSuborderTrackAndTraceErrors]

export type CustomerPortalUpdateSuborderTrackAndTraceResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type CustomerPortalUpdateSuborderTrackAndTraceResponse =
  CustomerPortalUpdateSuborderTrackAndTraceResponses[keyof CustomerPortalUpdateSuborderTrackAndTraceResponses]

export type CustomerPortalClaimInvitationData = {
  body: ValidateInvitationRequest
  path?: never
  query?: never
  url: '/cp/invitations/claim'
}

export type CustomerPortalClaimInvitationErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomerPortalClaimInvitationError =
  CustomerPortalClaimInvitationErrors[keyof CustomerPortalClaimInvitationErrors]

export type CustomerPortalClaimInvitationResponses = {
  /**
   * Successful Response
   */
  204: void
}

export type CustomerPortalClaimInvitationResponse =
  CustomerPortalClaimInvitationResponses[keyof CustomerPortalClaimInvitationResponses]

export type CustomerPortalValidateInvitationData = {
  body: ValidateInvitationRequest
  path?: never
  query?: never
  url: '/cp/invitations/validate'
}

export type CustomerPortalValidateInvitationErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError
}

export type CustomerPortalValidateInvitationError =
  CustomerPortalValidateInvitationErrors[keyof CustomerPortalValidateInvitationErrors]

export type CustomerPortalValidateInvitationResponses = {
  /**
   * Successful Response
   */
  200: ValidateInvitationResponse
}

export type CustomerPortalValidateInvitationResponse =
  CustomerPortalValidateInvitationResponses[keyof CustomerPortalValidateInvitationResponses]
